import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=b3da96bc&scoped=true&"
import script from "./downloadCenter.vue?vue&type=script&lang=js&"
export * from "./downloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./downloadCenter.vue?vue&type=style&index=0&id=b3da96bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3da96bc",
  null
  
)

export default component.exports